import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('journalEntryReport', [booksMenu])
  .controller('journalEntryReportController', journalEntryReportController)
  .name;
  
/* @ngInject */ function journalEntryReportController($scope, BooksSvc, BusyScreen, Session) {
  /*---------------------*/
  /* Sets default values */
  /*---------------------*/
  $scope.req = { reportFormat: 'PDF', sortByNumber: false };
  $scope.data = {};
  $scope.reportPage = Session.getSessionURL('/JournalEntryReport.aspx');

  /*--------------------------------------------------------*/
  /* Empty validation object to work with the csm validator */
  /*--------------------------------------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*---------------------------------*/
  /* Watches the accountID. If no    */
  /* entry, defaults the value to 0. */
  /*---------------------------------*/
  $scope.$watch('data.accountID', function (accountID) {
    $scope.req.accountID = accountID ? accountID : 0;
  });

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;

    BooksSvc.viewChartOfAccounts().then(function (resp) {
      $scope.accounts = resp.data;
    });
    BusyScreen.setBusy(false);
  });
}